module.exports = __webpack_public_path__ + "static/media/userIcon.a2476fe3.svg";